// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__83oUh","image":"styles_image__13Vw8","text":"styles_text__2Ebw0"};